module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "cover"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "titlepage"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/titlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-copyright"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "toc-dedication"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "Ref_22491a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/prologue#Ref_22491"
    }
  }, [_vm._v("PROLOGUE: Hyperspace Tier 19: Rowkog City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22494a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001#Ref_22494"
    }
  }, [_vm._v("CHAPTER ONE: Dervla, the planet Ong, the city of Cawl-Vesh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22419a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002#Ref_22419"
    }
  }, [_vm._v("CHAPTER TWO: The Permanent Sub-Proctor,  the city of Cawl-Vesh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22422a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter003#Ref_22422"
    }
  }, [_vm._v("CHAPTER THREE: Dervla, the planet Ong, the city of Cawl-Vesh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22425a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004#Ref_22425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22428a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005#Ref_22428",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE: Dervla, the planet Ong, outside Cawl-Vesh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22431a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006#Ref_22431",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22434a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007#Ref_22434",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN: Pyke, the planet Ong, Ustril’s  base in the desert")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22437a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008#Ref_22437",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT: Pyke, the Isle of Candles Simulation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22440a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009#Ref_22440",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22443a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010#Ref_22443",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22446a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter011#Ref_22446",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN: Dervla, on the planet Ong, inside a wrecked section of the Mighty Defender")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22449a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012#Ref_22449",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE: Pyke, in the Crystal Simulation, the city of Granah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22452a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter013#Ref_22452",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN: Pyke, on the planet Ong, in the wreck of the Mighty Defender, in the Steel Forest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22455a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014#Ref_22455",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN: Pyke, in the Crystal Simulation, the City of Granah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22458a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015#Ref_22458",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTEEN: Pyke, on the planet Ong, the wreck of the Mighty Defender, bridge section")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22461a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter016#Ref_22461",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN: Pyke—The Crystal Simulation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22464a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter017#Ref_22464",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN: Pyke—the planet Ong, the wreck of the Mighty Defender, the forward section")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22467a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter018#Ref_22467",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHTEEN: Dervla, the Crystal Simulation, the city of Granah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22470a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019#Ref_22470",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINETEEN: Pyke—the planet Ong, the wreck of the Mighty Defender, forward section")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22473a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020#Ref_22473",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY: Pyke—The Crystal Simulation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22476a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter021#Ref_22476",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-ONE: Pyke, the planet Ong, the wreck of the Mighty Defender, forward section")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22479a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter022#Ref_22479",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-TWO: Pyke, The Crystal Simulation, the Sublayer of the Dimensional Lattice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22482a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter023#Ref_22482",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-THREE: Pyke, the planet Ong, the wreck of the Mighty Defender, the bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22485a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter024#Ref_22485",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY-FOUR: Pyke—the Crystal Simulation,  the Isle of Candles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22488a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter025#Ref_22488",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE: Pyke, aboard the Scarabus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1",
    attrs: {
      "id": "Ref_22572a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgements#Ref_22572",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22566a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/adcard#Ref_22566"
    }
  }, [_vm._v("By Michael Cobley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "Ref_22578a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/extras",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Extras")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chaptern",
    attrs: {
      "id": "Ref_22575a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix001#Ref_22575",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meet the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chaptern",
    attrs: {
      "id": "Ref_22581a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix002#Ref_22581",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Preview of "), _c('em', [_vm._v("A Big Ship at the Edge of the Universe")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chaptern",
    attrs: {
      "id": "Ref_22584a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appendix003#Ref_22584",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Preview of "), _c('em', [_vm._v("Adrift")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "newsletter1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/newsletterSignup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orbit Newsletter")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0